import React, { useState, useEffect } from "react";
import { Stepper, Step, StepLabel, Container, Input, useEventCallback } from '@mui/material';
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import { Autocomplete } from '@mui/material';

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import { useLocation } from 'react-router-dom';
import { Radio, RadioGroup, FormLabel } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import WorkshopNavbar from "../../frontend/WorkShop/WorkshopNavbar/WorkshopNavbar";
//import WorkshopFooter from "./WorkhopFooter/WorkshopFooter";
import NewVersionAbstractFooter from "../AbstractAuth/NewVersion/NewVersionAnstractFooter";
import { useDeadline } from "../../contexts/DeadlineContext";

const steps = ['Step 1', 'Step 2', 'Step 3']; // Define your steps



function createData(
    id,
    coupon_code,
    workshop_id,
    disount,



) {
    return { id, coupon_code, workshop_id, disount, };
}



const rowssss = [
    createData(1, '123', 6),
    createData(1, 'kfsRY7IRI'),
    createData(2, 'micSSQ4CA'),
    createData(3, '789', 5),
    createData(4, '963', 7),
    createData(5, '258', 25),
    createData(6, '147', 26),



].sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

const coupons = [
    { id: 1, code: '123', workshop_id: 6 },
    { id: 2, code: 'kfsRY7IRcI', workshop_id: 6 },
    { id: 3, code: 'micSSQ4CA', workshop_id: 28 },
    { id: 4, code: 'fixFDMJIK', workshop_id: 5 },
    { id: 5, code: '963', workshop_id: 7 },
    { id: 6, code: '258', workshop_id: 25 },
    { id: 7, code: '147', workshop_id: 26 },
];

const rows = [
    createData(1, '123', 6),
    createData(1, 'kfsRY7IRI'),
    createData(2, 'micSSQ4CA'),
    createData(3, 'fixFDMJIK', 5),
    createData(4, '963', 7),
    createData(5, '258', 25),
    createData(6, '147', 26),
].map((row, index) => {
    const coupon = coupons.find((coupon) => coupon.code === row.couponCode);
    const discount = coupon ? coupon.discount : 0;
    return { ...row, discount };
}).sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

const countries = [
    'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
    'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
    'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia',
    'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica',
    'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt',
    'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon',
    'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
    'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel',
    'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos',
    'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi',
    'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova',
    'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
    'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau',
    'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia',
    'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia',
    'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan',
    'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania',
    'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda',
    'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam',
    'Yemen', 'Zambia', 'Zimbabwe'
];

const WorkShopParticpantForm = () => {
    const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();

    //const bannerImage = `${process.env.PUBLIC_URL}/Abstract/loginBanerImage/abanner-bg.jpg`;
    //const bannerImage = `${process.env.PUBLIC_URL}/Workshops/WorkshopImages/scfns-workshop-bg.jpg`;
    //const bannerImage = `${process.env.PUBLIC_URL}/Workshops/WorkshopImages/banner-image_workshop.jpg`;
    const gradientBackground = '#05597D';

    const location = useLocation();
    const URL = window.location.href;
    const id = document.URL.split("/").slice(-1)[0];

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const cardStyles = {
        width: isSmallScreen ? '85vw' : isMediumScreen ? '80vw' : '60vw',
        margin: 'auto',
    };



    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState({
        // Initialize form data here
        firstName: '',
        lastName: '',
        email: '',
    });
    const history = useHistory();
    const [disabled, setdisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isChecked, setChecked] = useState(false);
    const eventName = localStorage.getItem('eventname');
    const eventid = localStorage.getItem('eventid');
    const [nameTitle, setNameTitle] = useState('');
    const [gender, setGender] = useState(''); // state to hold the selected value
    const [country, setCountry] = useState('Saudi Arabia');
    const [registrationType, setRegistrationType] = useState('');
    const [assignModule, setassignModules] = useState([]);
    const [checkmodules, setCheckedmodules] = useState([]);
    const [workshopCategoryData, setWorkShopCategoryData] = useState([]);
    const [singleWorkShopCategory, setSingleWorkShopCategory] = useState('');
    const [selectedWorkshops, setSelectedWorkshops] = useState([]);
    const [selectedWorkshopAmounts, setSelectedWorkshopAmounts] = useState([]);
    const [discountMessages, setDiscountMessages] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [disabledInputs, setDisabledInputs] = useState({});
    const [showCouponInputs, setShowCouponInputs] = useState({});
    const [workshopUsedCoupeon, setWorkshopUsedCoupeon] = useState([]);
    const workshop_particpant_email = localStorage.getItem('workshop_particpant_email');
    const [currentDateTime, setCurrentDateTime] = useState(new Date().toISOString());
    const [workshopTotalSeatCount, setWorkshopTotalSeatCount] = useState();
    const [addWorkShopParticpant, setAddWorkShopParticpant] = React.useState({
        workShop_partecpant_name: "",
        instituteWorkPlace: "",
        city: "",
        phone: "",
        particent_email: "",
        saudiCouncilno: "",
        price: "",
        profession: "",
        // password: "",
        // phone: "",
        // date: "",
        // address: "",
        // details: "",
        error_list: [],
    });




    useEffect(() => {
        axios.get(`api/workshop-category-front-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wcategoryData = res.data.workshopCategories;
                const currentDateTime = res.data.currentDateTime;

                setWorkShopCategoryData(wcategoryData);
                setCurrentDateTime(currentDateTime);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);
    useEffect(() => {
        axios.get(`api/workshop-participant-used-coupeona?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const usedCoupen = res.data.usedCoupons;
                setWorkshopUsedCoupeon(usedCoupen);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);

    const [eventOptionsSetup, setEventOptionsSetup] = useState({
        cate_to_abst: "",
        guest_email_action: "",
        guest_email_action: "",
        workshop_setup_status: "",
        guestBadgeImage: "",
        error_list: [],
    });


    React.useEffect(() => {
        axios.get(`api/front-end-option-setup?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getOptionsData = res.data.getOptions;
                setEventOptionsSetup(getOptionsData);
                // Parse the JSON string for abstractSponserLogos


            }
        });
    }, [eventid]);



    const handleregistration = (e) => {
        const selectedRegistrationType = e.target.value;

        // Trigger API request with the selectedRegistrationType
        axios.get(`api/workshop-category-front-single/${selectedRegistrationType}`)
            .then((res) => {
                if (res.status === 200) {
                    const singleWorkShopData = res.data.swsd;
                    setSingleWorkShopCategory(singleWorkShopData);
                    setWorkshopTotalSeatCount(res.data.totalSeatCount);
                    // console.log("singleWorkShopData", singleWorkShopData)
                    // console.log("setWorkshopTotalSeatCount", res.data.totalSeatCount)
                }
                // } else {
                //   swal('Error', 'Check API Something Wrong', 'error');
                // }
            })
            .catch((error) => {
                console.error('API Error:', error);
                swal('Error', 'An error occurred while fetching data from the API', 'error');
            });

        // Update the state with the selected registration type
        setRegistrationType(selectedRegistrationType);
    };
    const [inputValues, setInputValues] = useState({}); // Use an object to store coupon codes for each workshop

    const handleCouponCodeChange = (workshopId, enteredCode) => {
        setInputValues({ ...inputValues, [workshopId]: enteredCode });
    };


    //const couponCode = '123'; // Assuming coupon code is a string
    const [couponCodes, setCouponCodes] = useState({});


    useEffect(() => {
        axios.get(`api/workshop-manage-coupon-index-front?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wksp = res.data.workshopCouponFront;
                setCouponCodes(wksp);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);


    const [colorMap, setColorMap] = useState({});

    const handleCheckboxChange = (event, workshop, workshop_amount) => {
        const { id, workshop_url, workshop_date, workshop_start_time, workshop_end_time, workshop_code, workshop_name, workshop_coupon } = workshop;

        // Check if the workshop is already selected
        const isAlreadySelected = selectedWorkshops.some(
            (selectedWorkshop) => selectedWorkshop.id === id
        );


        if (event.target.checked && !isAlreadySelected) {
            // Generate a unique color for the row based on specific fields
            const uniqueColor = getColorForFields(workshop_url, workshop_date, workshop_start_time);

            setSelectedWorkshops([...selectedWorkshops, workshop]);
            setSelectedWorkshopAmounts([...selectedWorkshopAmounts, { id, workshop_code, workshop_amount, workshop_name, workshop_coupon }]);

            // Update the color map with the unique color for the specific row values
            setColorMap(prevColorMap => ({
                ...prevColorMap,
                [`${workshop_url}-${workshop_date}-${workshop_start_time}`]: uniqueColor,
            }));
        } else if (!event.target.checked && isAlreadySelected) {
            setSelectedWorkshops(selectedWorkshops.filter((w) => w.id !== id));

            // Remove the item with the matching id
            setSelectedWorkshopAmounts(selectedWorkshopAmounts.filter((item) => item.id !== id));

            // Clear the color map entry when the row is unchecked
            setColorMap(prevColorMap => {
                const newColorMap = { ...prevColorMap };
                delete newColorMap[`${workshop_url}-${workshop_date}-${workshop_start_time}`];
                return newColorMap;
            });
        }
    };


    const isCheckboxDisabled = (workshop) => {
        const { id, workshop_url, workshop_date, workshop_start_time, workshop_end_time, workshop_no_ofseats, } = workshop;
        // Check if another workshop with the same values is already selected

        // const isAlreadySelected = selectedWorkshops.some(
        //     (selectedWorkshop) =>
        //         selectedWorkshop.workshop_url === workshop_url &&
        //         selectedWorkshop.workshop_date === workshop_date &&
        //         selectedWorkshop.workshop_start_time === workshop_start_time &&
        //         //selectedWorkshop.workshop_end_time === workshop_end_time &&
        //         selectedWorkshop.id !== id
        // );
        //eventOptionsSetup.workshop_setup_status == 0
        //let byDay = 0;

        // const isAlreadySelected = selectedWorkshops.some(
        //     (selectedWorkshop) =>
        //         eventOptionsSetup.workshop_setup_status === 1 ? selectedWorkshop.workshop_date === workshop_date && selectedWorkshop.id !== id
        //             : selectedWorkshop.workshop_url === workshop_url &&
        //             selectedWorkshop.workshop_date === workshop_date &&
        //             selectedWorkshop.workshop_start_time === workshop_start_time &&
        //             selectedWorkshop.id !== id
        // );

        const isAlreadySelected = selectedWorkshops.some(
            (selectedWorkshop) =>
                eventOptionsSetup.workshop_setup_status === 1
                    ? selectedWorkshop.id !== id  // If status is 1, disable all workshops
                    : selectedWorkshop.workshop_url === workshop_url &&
                    selectedWorkshop.workshop_date === workshop_date &&
                    selectedWorkshop.workshop_start_time === workshop_start_time &&
                    selectedWorkshop.id !== id
        );


        // Convert workshop date and time to milliseconds since Unix epoch
        const workshopDateTime = new Date(`${workshop_date}T${workshop_start_time}`).getTime();
        const currentDateTime = new Date().getTime();
        const isTimePassed = workshopDateTime < currentDateTime;

        const workshopIdToMatch = workshop.id; // The workshop ID you want to match
        //const countWorkhops =  workshopTotalSeatCount.filter(workshop => workshop.workshop_id === workshopIdToMatch).length;
        const countWorkshops = Array.isArray(workshopTotalSeatCount)
            ? workshopTotalSeatCount.filter(workshop => workshop.workshop_id === workshopIdToMatch).length
            : 0;
        const isSeatLimitReached = countWorkshops >= workshop.workshop_no_ofseats;
        //console.log(countWorkshops)
        // Combine both conditions to determine if the checkbox should be disabled
        const isDisabled = isAlreadySelected || isTimePassed || isSeatLimitReached;

        let seatLimitMessage = '';
        if (isSeatLimitReached) {
            // seatLimitMessage = `${countWorkhops} All Seats Full`;
            seatLimitMessage = `All seats are full`;
        }

        // Check if there's a color assigned for the specific row values and use it


        //condition by day
        let color = '';
        if (eventOptionsSetup.workshop_setup_status === 1) {
            color = '#fff'; // default white if status is 1
        } else {
            // Check if colorMap exists and the key is valid
            const colorFromMap = colorMap[`${workshop_url}-${workshop_date}-${workshop_start_time}`];
            color = colorFromMap || '#fff'; // Fallback to white if not found
        }


        return { isDisabled, color, seatLimitMessage };
    };


    // Function to generate a unique color based on specific fields
    const getColorForFields = (url, date, startTime) => {
        return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    };

    useEffect(() => {

        Object.keys(discountMessages).forEach(workshopId => {

        });
    }, [discountMessages]);

    useEffect(() => {

    }, [totalAmount]);
    const [usedCouponMessage, setUsedCouponMessage] = useState([]);
    useEffect(() => {
        Object.keys(usedCouponMessage).forEach(workshopId => {
            const message = usedCouponMessage[workshopId];

        });
    }, [usedCouponMessage]);


    useEffect(() => {
        const newTotalAmount = selectedWorkshopAmounts.reduce((acc, workshop) => {
            let discount = 0;
            const singleWorkshopAmount = Number(workshop.workshop_amount);
            const matchingCoupon = couponCodes.find(couponValue => inputValues[workshop.id] === couponValue.coupon_code);
            //const useCoupon = coupons.filter(couponsVal => inputValues[workshop.id] === couponsVal.code);
            const useCoupon = workshopUsedCoupeon.filter(couponsVal => inputValues[workshop.id] === couponsVal.coupon_code);
            if (matchingCoupon) {
                if (matchingCoupon.coupon_amout_type === "percentage" && workshop.id === matchingCoupon.workshop_id &&
                    inputValues[workshop.id] === matchingCoupon.coupon_code) {
                    if (useCoupon.length > 0) {
                        const messageUsedCoupon = 'The Coupon is Already used';
                        setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                        //return numericAmount; // Early return if coupon is already used
                    }
                    else {
                        const currentDate = new Date(); // Current date
                        //const couponExpireDate = "2024-05-28"; // Coupon expiry date
                        // Convert current date to the format "YYYY-MM-DD"
                        const currentYear = currentDate.getFullYear();
                        const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
                        const currentDay = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if needed
                        const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                        const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                        if (isTimePassedExpired) {
                            const messageUsedCoupon = 'The Coupon is Expired';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                        }
                        else {
                            discount = (singleWorkshopAmount * matchingCoupon.coupon_amout_value) / 100;
                        }

                    }

                } else if (matchingCoupon.coupon_amout_type === "fixed" && workshop.id === matchingCoupon.workshop_id &&
                    inputValues[workshop.id] === matchingCoupon.coupon_code) {
                    if (useCoupon.length > 0) {
                        const messageUsedCoupon = 'The Coupon is Already used';
                        setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                    }
                    else {
                        const currentDate = new Date(); // Current date
                        //const couponExpireDate = "2024-05-28"; // Coupon expiry date
                        // Convert current date to the format "YYYY-MM-DD"
                        const currentYear = currentDate.getFullYear();
                        const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
                        const currentDay = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if needed

                        const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;

                        const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                        if (isTimePassedExpired) {
                            const messageUsedCoupon = 'The Coupon is Expired';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                        }
                        else {
                            discount = matchingCoupon.coupon_amout_value;
                        }

                    }

                }
                if (!isNaN(singleWorkshopAmount) && discount > 0) {
                    const message = `Discount applied for workshop ${workshop.id}. Coupon Code: ${inputValues[workshop.id]}`;
                    setDiscountMessages(prevMessages => ({ ...prevMessages, [workshop.id]: message }));
                    setDisabledInputs(prevDisabled => ({ ...prevDisabled, [workshop.id]: true }));
                }
            }
            return acc + (singleWorkshopAmount - discount);
        }, 0);

        setTotalAmount(newTotalAmount);
    }, [selectedWorkshopAmounts, couponCodes, inputValues]);

    const toggleCouponInput = (workshopId) => {
        setShowCouponInputs((prevState) => {
            const newState = {
                ...prevState,
                [workshopId]: !prevState[workshopId],
            };
            // console.log("Toggled showCouponInputs:", newState); // Log the new state
            return newState;
        });
    };

    const handleInput = (e) => {
        const value = e.target.value;
        const inputName = e.target.name;
        setAddWorkShopParticpant({ ...addWorkShopParticpant, [e.target.name]: e.target.value });
        localStorage.setItem(inputName, value);

    }

    const handleCountry = (e) => {
        const selectCountry = e.target.value;
        setCountry(selectCountry);
        localStorage.setItem('selectedCountry', selectCountry);
    }

    const handleChange = (event) => {
        const selectedGender = event.target.value;
        setGender(selectedGender);
        localStorage.setItem('gender', selectedGender);
    };

    // Function to handle radio button change


    const handleNameTitle = (e) => {
        const selectNametitle = e.target.value;

        setNameTitle(selectNametitle);
        localStorage.setItem('nameTitle', selectNametitle)
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleExtraButtonClick = () => {
        // Move back to Step 1
        setActiveStep(0);
    };

    const handleInputChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value,
        }));
    };
    // console.log(singleWorkShopCategory.id)
    const { error_list } = addWorkShopParticpant;
    const handleSubmitBank = (e) => {
        e.preventDefault();

        // Set loading state to true when button is clicked
        const paymentBank = "paymentBank";
        const data = {
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: addWorkShopParticpant.saudiCouncilno,
            participant_name: addWorkShopParticpant.workShop_partecpant_name,
            participant_email: addWorkShopParticpant.particent_email === "" ? workshop_particpant_email : addWorkShopParticpant.particent_email,
            participant_workshop_categoy: singleWorkShopCategory.id,
            participant_contact: addWorkShopParticpant.phone,
            participant_profession: addWorkShopParticpant.profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: addWorkShopParticpant.city,
            selectedWorkshopAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentBank,


        };

        {
            data.eventid == "" ? setLoading(false) : data.name_title == "" ? setLoading(false) :
                data.participant_saudi_council_no == "" ? setLoading(false) : data.participant_name == "" ? setLoading(false) :
                    data.participant_email == "" ? setLoading(false) : data.participant_workshop_categoy == "" ? setLoading(false) :
                        data.participant_contact == "" ? setLoading(false) : data.participant_profession == "" ? setLoading(false) :
                            data.participant_gender == "" ? setLoading(false) : data.participant_country == "" ? setLoading(false) :
                                data.paymentBank == "" ? setLoading(false) : setLoading(true)
        }

        // {
        //     data.eventid == "" ? setLoading(false) : data.name_title == "" ? setLoading(false) :
        //         data.participant_saudi_council_no == "" ? setLoading(false) : data.participant_name == "" ? setLoading(false) :
        //             data.participant_email == "" ? setLoading(false) : data.participant_workshop_categoy == "" ? setLoading(false) :
        //                 data.participant_contact == "" ? setLoading(false) : data.participant_profession == "" ? setLoading(false) :
        //                     data.participant_gender == "" ? setLoading(false) : data.participant_country == "" ? setLoading(false) :
        //                         data.selectedWorkshopAmounts == "" ? setLoading(false) :
        //                             data.totalAmount == "" ? setLoading(false) : data.paymentBank == "" ? setLoading(false) : setLoading(true)
        // }


        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/workshop-particpant-regisrtation`, data, config).then(res => {

                if (res.data.status === 200) {
                    const participantId = res.data.participantId;

                    swal('Success', res.data.message, 'success');

                    // history.push('/workshop/particpant-form/thank-you');
                    history.push(`/workshop/thank-you/${participantId}`);

                    return false;
                }
                else {

                    setAddWorkShopParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error })

                }

            }).catch(error => {
                setLoading(false); // Set loading state back to false in case of error
                console.error('Error:', error);
            });
        }).catch(error => {
            setLoading(false); // Set loading state back to false in case of error
            console.error('Error:', error);
        });
    };

    const handleSubmitOnline = (e) => {
        e.preventDefault();
        // setLoading(true); // Set loading state to true when button is clicked

        const paymentOnline = "paymentOnline";
        const data = {
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: addWorkShopParticpant.saudiCouncilno,
            participant_name: addWorkShopParticpant.workShop_partecpant_name,
            participant_email: addWorkShopParticpant.particent_email === "" ? workshop_particpant_email : addWorkShopParticpant.particent_email,
            participant_workshop_categoy: singleWorkShopCategory.id,
            participant_contact: addWorkShopParticpant.phone,
            participant_profession: addWorkShopParticpant.profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: addWorkShopParticpant.city,
            selectedWorkshopAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentOnline,
        };
        {
            data.eventid == "" ? setLoading(false) : data.name_title == "" ? setLoading(false) :
                data.participant_saudi_council_no == "" ? setLoading(false) : data.participant_name == "" ? setLoading(false) :
                    data.participant_email == "" ? setLoading(false) : data.participant_workshop_categoy == "" ? setLoading(false) :
                        data.participant_contact == "" ? setLoading(false) : data.participant_profession == "" ? setLoading(false) :
                            data.participant_gender == "" ? setLoading(false) : data.participant_country == "" ? setLoading(false) :
                                data.selectedWorkshopAmounts == "" ? setLoading(false) :
                                    data.totalAmount == "" ? setLoading(false) : data.paymentBank == "" ? setLoading(false) : setLoading(true)
        }

        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/onlinepayment-workshop-particpant-store`, data, config).then(res => {
                setLoading(false); // Set loading state back to false after operation completes
                if (res.data.status === 200) {
                    const participantId = res.data.participantId;
                    swal('Success', res.data.message, 'success');
                    console.log(res.data);
                    window.location.href = res.data.redirect.redirect_url;
                } else {
                    setAddWorkShopParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error });
                }
            }).catch(error => {
                setLoading(false); // Set loading state back to false in case of error
                console.error('Error:', error);
            });
        }).catch(error => {
            setLoading(false); // Set loading state back to false in case of error
            console.error('Error:', error);
        });
    };

    const handleSubmitCash = (e) => {
        e.preventDefault();
        const paymentCash = "paymentCash";
        const data = {
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: addWorkShopParticpant.saudiCouncilno,
            participant_name: addWorkShopParticpant.workShop_partecpant_name,
            participant_email: addWorkShopParticpant.particent_email === "" ? workshop_particpant_email : addWorkShopParticpant.particent_email,
            participant_workshop_categoy: singleWorkShopCategory.id,
            participant_contact: addWorkShopParticpant.phone,
            participant_profession: addWorkShopParticpant.profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: addWorkShopParticpant.city,
            selectedWorkshopAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentCash,

        };

        {
            data.eventid == "" ? setLoading(false) : data.name_title == "" ? setLoading(false) :
                data.participant_saudi_council_no == "" ? setLoading(false) : data.participant_name == "" ? setLoading(false) :
                    data.participant_email == "" ? setLoading(false) : data.participant_workshop_categoy == "" ? setLoading(false) :
                        data.participant_contact == "" ? setLoading(false) : data.participant_profession == "" ? setLoading(false) :
                            data.participant_gender == "" ? setLoading(false) : data.participant_country == "" ? setLoading(false) :
                                data.selectedWorkshopAmounts == "" ? setLoading(false) :
                                    data.totalAmount == "" ? setLoading(false) : data.paymentBank == "" ? setLoading(false) : setLoading(true)
        }
        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/workshop-particpant-regisrtation`, data, config).then(res => {

                if (res.data.status === 200) {
                    const participantId = res.data.participantId;

                    swal('Success', res.data.message, 'success');
                    history.push(`/workshop/thank-you/${participantId}`);
                    return false;
                }
                else {

                    setAddWorkShopParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error })

                }

            });


        });



    };


    const handleSubmitFree = (e) => {
        e.preventDefault();

        const paymentFree = "paymentFree";
        const data = {
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: addWorkShopParticpant.saudiCouncilno,
            participant_name: addWorkShopParticpant.workShop_partecpant_name,
            participant_email: addWorkShopParticpant.particent_email === "" ? workshop_particpant_email : addWorkShopParticpant.particent_email,
            participant_workshop_categoy: singleWorkShopCategory.id,
            participant_contact: addWorkShopParticpant.phone,
            participant_profession: addWorkShopParticpant.profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: addWorkShopParticpant.city,
            selectedWorkshopAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentFree,

        };

        {
            data.eventid == "" ? setLoading(false) : data.name_title == "" ? setLoading(false) :
                data.participant_saudi_council_no == "" ? setLoading(false) : data.participant_name == "" ? setLoading(false) :
                    data.participant_email == "" ? setLoading(false) : data.participant_workshop_categoy == "" ? setLoading(false) :
                        data.participant_contact == "" ? setLoading(false) : data.participant_profession == "" ? setLoading(false) :
                            data.participant_gender == "" ? setLoading(false) : data.participant_country == "" ? setLoading(false) :
                                data.selectedWorkshopAmounts == "" ? setLoading(false) :
                                    data.totalAmount == "" ? setLoading(false) : data.paymentBank == "" ? setLoading(false) : setLoading(true)
        }
        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/workshop-particpant-free-regisrtation`, data, config).then(res => {

                if (res.data.status === 200) {
                    const participantId = res.data.participantId;

                    swal('Success', res.data.message, 'success');
                    history.push(`/workshop/thank-you/${participantId}`);
                    return false;
                }
                else {

                    setAddWorkShopParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error })

                }

            });


        });
    }

    //const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isMobile = useMediaQuery('(max-width:600px)');
    const renderSelectedWorkshopInfo = () => {

        const handleRemoveWorkshop = (workshopIdToRemove) => {

            const updatedWorkshops = selectedWorkshopAmounts.filter(workshop => workshop.id !== workshopIdToRemove);
            // Update the state with the filtered array
            //console.log(updatedWorkshops)
            setSelectedWorkshopAmounts(updatedWorkshops);
        }


        return (
            <div>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {
                                    isMobile ? (
                                        <>
                                            <TableCell colSpan={4} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                WorkShop Details
                                            </TableCell>
                                        </>
                                    ) : (
                                        <>
                                            <TableCell>WorkShop Code</TableCell>
                                            <TableCell>WorkShop Name</TableCell>
                                            <TableCell>Coupon</TableCell>

                                            <TableCell align="right">Workshop Amount</TableCell>
                                            <TableCell align="right">Action</TableCell>
                                        </>
                                    )}

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedWorkshopAmounts && selectedWorkshopAmounts.map((selectedWorkshop, index) => (
                                <TableRow key={selectedWorkshop.id}>
                                    {
                                        isMobile ? (
                                            <>
                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>No:  {index + 1} </strong>
                                                    <hr></hr>
                                                </Box>
                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>WorkShop Code: </strong> {selectedWorkshop.workshop_code}
                                                </Box>
                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>WorkShop Name: </strong> {selectedWorkshop.workshop_name}
                                                </Box>
                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                    <strong>Coupon:</strong>

                                                    {selectedWorkshop.workshop_coupon === 1 && (
                                                        <Checkbox
                                                            checked={!!showCouponInputs[selectedWorkshop.id]}  // Use !! to convert to boolean
                                                            onChange={() => toggleCouponInput(selectedWorkshop.id)}
                                                        />
                                                    )}
                                                    <div style={{
                                                        marginTop: '10px', // Default margin
                                                        '@media (max-width: 600px)': {
                                                            marginTop: '5px', // Adjusted margin for smaller screens
                                                        }
                                                    }}>

                                                        {showCouponInputs[selectedWorkshop.id] && selectedWorkshop.workshop_coupon === 1 && (

                                                            <Input
                                                                type="text"
                                                                fullWidth
                                                                placeholder="Your Coupon Code"
                                                                value={inputValues[selectedWorkshop.id] || ''}
                                                                onChange={(e) => handleCouponCodeChange(selectedWorkshop.id, e.target.value)}
                                                            // disabled={disabledInputs[selectedWorkshop.id]}

                                                            />

                                                        )}

                                                        {discountMessages[selectedWorkshop.id] && (
                                                            <div>
                                                                <h3 style={{ color: "green" }}>Coupon Applied</h3>
                                                            </div>

                                                        )}
                                                        {!discountMessages[selectedWorkshop.id] && usedCouponMessage[selectedWorkshop.id] && (
                                                            <div>
                                                                <h3 style={{ color: "green" }}>{usedCouponMessage[selectedWorkshop.id]}</h3>
                                                            </div>
                                                        )}
                                                    </div>

                                                </Box>
                                                <Box style={{ flexBasis: '100%', margin: '5px' }} align="right">
                                                    <TableCell >
                                                        {/* Remove button with onClick event */}
                                                        <Button onClick={() => handleRemoveWorkshop(selectedWorkshop.id)}>Remove</Button>
                                                    </TableCell>
                                                </Box>

                                            </>
                                        ) : (
                                            <>
                                                <TableCell>{selectedWorkshop.workshop_code}</TableCell>
                                                <TableCell>{selectedWorkshop.workshop_name}</TableCell>
                                                <TableCell >
                                                    {selectedWorkshop.workshop_coupon === 1 && (
                                                        <Checkbox
                                                            checked={!!showCouponInputs[selectedWorkshop.id]}  // Use !! to convert to boolean
                                                            onChange={() => toggleCouponInput(selectedWorkshop.id)}
                                                        />
                                                    )}
                                                    <div style={{
                                                        marginTop: '10px', // Default margin
                                                        '@media (max-width: 600px)': {
                                                            marginTop: '5px', // Adjusted margin for smaller screens
                                                        }
                                                    }}>

                                                        {showCouponInputs[selectedWorkshop.id] && selectedWorkshop.workshop_coupon === 1 && (

                                                            <Input
                                                                type="text"
                                                                fullWidth
                                                                placeholder="Your Coupon Code"
                                                                value={inputValues[selectedWorkshop.id] || ''}
                                                                onChange={(e) => handleCouponCodeChange(selectedWorkshop.id, e.target.value)}
                                                            // disabled={disabledInputs[selectedWorkshop.id]}

                                                            />

                                                        )}

                                                        {discountMessages[selectedWorkshop.id] && (
                                                            <div>
                                                                <h3 style={{ color: "green" }}>Coupon Applied</h3>
                                                            </div>

                                                        )}
                                                        {!discountMessages[selectedWorkshop.id] && usedCouponMessage[selectedWorkshop.id] && (
                                                            <div>
                                                                <h3 style={{ color: "green" }}>{usedCouponMessage[selectedWorkshop.id]}</h3>
                                                            </div>
                                                        )}
                                                    </div>
                                                </TableCell>
                                                <TableCell align="right">{selectedWorkshop.workshop_amount}</TableCell>
                                                <TableCell align="right">
                                                    {/* Remove button with onClick event */}
                                                    <Button onClick={() => handleRemoveWorkshop(selectedWorkshop.id)}>Remove</Button>
                                                </TableCell>
                                            </>

                                        )}

                                </TableRow>
                            ))}
                            <TableRow>
                                <TableCell colSpan={5} align="right" style={{ fontWeight: 'bold' }}> Amount: {totalAmount} </TableCell>
                            </TableRow>
                        </TableBody>

                    </Table>
                </TableContainer>
                <Box noValidate sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    {isMobile ? (
                        <>

                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', marginTop: "20px", }}>
                                {abstractHomeSetup.online_status == 1 && (
                                    <Button
                                        onClick={handleSubmitOnline}
                                        variant="contained"
                                        sx={{
                                            backgroundColor: abstractHomeSetup.color_code_two
                                                ? abstractHomeSetup.color_code_two
                                                : gradientBackground,
                                            flex: '1 1 48%', // Adjusts button width to fit two in a row
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Loading...' : 'Online'}
                                    </Button>
                                )}

                                {abstractHomeSetup.bank_status == 1 && (
                                    <Button
                                        onClick={handleSubmitBank}
                                        variant="contained"
                                        sx={{
                                            backgroundColor: abstractHomeSetup.color_code_two
                                                ? abstractHomeSetup.color_code_two
                                                : gradientBackground,
                                            flex: '1 1 48%',
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Loading...' : 'Bank'}
                                    </Button>
                                )}

                                {abstractHomeSetup.cash_status == 1 && (
                                    <Button
                                        onClick={handleSubmitCash}
                                        variant="contained"
                                        sx={{
                                            backgroundColor: abstractHomeSetup.color_code_two
                                                ? abstractHomeSetup.color_code_two
                                                : gradientBackground,
                                            flex: '1 1 48%',
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Loading...' : 'Cash'}
                                    </Button>
                                )}

                                {abstractHomeSetup.free_status == 1 && (
                                    <Button
                                        onClick={handleSubmitFree}
                                        variant="contained"
                                        sx={{
                                            backgroundColor: abstractHomeSetup.color_code_two
                                                ? abstractHomeSetup.color_code_two
                                                : gradientBackground,
                                            flex: '1 1 48%',
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Loading...' : 'Register'}
                                    </Button>
                                )}
                            </div>
                        </>
                    ) : (
                        <>
                            {abstractHomeSetup.online_status == 1 && (
                                <Button
                                    onClick={handleSubmitOnline}
                                    variant="contained"
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        ml: 4,
                                        mr: 2,
                                        backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                        cursor: loading ? 'not-allowed' : 'pointer', // Disable pointer events when loading
                                        opacity: loading ? 0.6 : 1, // Reduce opacity when loading
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Online'}
                                </Button>
                            )}

                            {abstractHomeSetup.bank_status == 1 && (
                                <Button
                                    onClick={handleSubmitBank}
                                    variant="contained"
                                    sx={{
                                        mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Bank'}
                                </Button>
                            )}

                            {abstractHomeSetup.cash_status == 1 && (
                                <Button
                                    onClick={handleSubmitCash}
                                    variant="contained"
                                    sx={{
                                        mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Cash'}
                                </Button>
                            )}

                            {abstractHomeSetup.free_status == 1 && (
                                <Button
                                    onClick={handleSubmitFree}
                                    variant="contained"
                                    sx={{
                                        mt: 3, mb: 2, backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Register'}
                                </Button>
                            )}
                        </>
                    )}


                </Box>


                {/* <Box noValidate sx={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                    <Grid container justifyContent="space-between">

                        <Button
                            variant="contained"
                            color="primary"
                            // onClick={handleNext}
                            onClick={handleBack}
                            sx={{
                                mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                    ? abstractHomeSetup.color_code_two
                                    : gradientBackground,
                            }}
                        >
                            {activeStep === steps.length - 1 ? 'Back' : 'BAck'}
                        </Button>

                        {abstractHomeSetup.online_status == 1 && (
                            <Button
                                onClick={handleSubmitOnline}
                                variant="contained"
                                sx={{
                                    mt: 3,
                                    mb: 2,
                                    ml: 4,
                                    mr: 2,
                                    backgroundColor: abstractHomeSetup.color_code_two
                                        ? abstractHomeSetup.color_code_two
                                        : gradientBackground,
                                    cursor: loading ? 'not-allowed' : 'pointer', // Disable pointer events when loading
                                    opacity: loading ? 0.6 : 1, // Reduce opacity when loading
                                }}
                                disabled={loading} // Disable the button when loading
                            >
                                {loading ? 'Loading...' : 'Online'}
                            </Button>

                        )}

                        {abstractHomeSetup.bank_status == 1 && (
                            <Button
                                onClick={handleSubmitBank}
                                variant="contained"
                                sx={{
                                    mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                        ? abstractHomeSetup.color_code_two
                                        : gradientBackground,
                                }}
                                disabled={loading}
                            >
                                {loading ? 'Loading...' : 'Register'}
                            </Button>
                        )}


                        {abstractHomeSetup.cash_status == 1 && (


                            <Button
                                onClick={handleSubmitCash}
                                variant="contained"
                                sx={{
                                    mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                        ? abstractHomeSetup.color_code_two
                                        : gradientBackground,
                                }}
                                disabled={loading}
                            >
                                {loading ? 'Loading...' : 'Cash'}
                            </Button>
                        )}

                        {abstractHomeSetup.free_status == 1 && (
                            <Button
                                onClick={handleSubmitFree}
                                variant="contained"
                                sx={{
                                    mt: 3, mb: 2, backgroundColor: abstractHomeSetup.color_code_two
                                        ? abstractHomeSetup.color_code_two
                                        : gradientBackground,
                                }}
                                disabled={loading}
                            >
                                {loading ? 'Loading...' : 'Free'}
                            </Button>
                        )}

                    </Grid>
                </Box> */}


            </div>
        );
    };


    return (
        <div>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <WorkshopNavbar />
            </Grid>

            <Grid container spacing={2} >
                <Box
                    sx={{
                        position: 'relative',
                        marginTop: '10px',
                        width: '100%',
                        height: isSmallScreen ? '200px' : '400px', // Adjust height for small screens
                        //backgroundImage: `url(${bannerImage})`,
                        backgroundImage: `url(${abstractHomeSetup.workshopBannerImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: isSmallScreen ? 'center' : 'left',
                        padding: isSmallScreen ? '10px' : '20px', // Adjust padding for small screens
                        color: 'white',
                    }}
                >
                    {/* <Typography variant={isSmallScreen ? 'h6' : 'h2'} component="div">
                        Workshop Management System
                    </Typography> */}
                </Box>

                <Grid container justifyContent="center" marginTop="40px" >
                    <Grid item xs={12} sm={12} md={12} lg={8}>
                        <Typography
                            component="h1"
                            variant="h5"
                            sx={{
                                textAlign: 'center', // Center the text
                            }}>
                            WorkShop Participant Details
                        </Typography>

                        <Grid item xs={12}>
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Grid>
                        <div>
                            {activeStep === steps.length ? (
                                <div >

                                    <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
                                        <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>


                                            {error_list && Object.keys(error_list).length > 0 && (
                                                <div>
                                                    {Object.keys(error_list).map((fieldName) => (
                                                        <div key={fieldName}>
                                                            {error_list[fieldName].map((error, index) => (
                                                                <span key={index} style={{ color: 'red' }}>{error}</span>
                                                            ))}
                                                        </div>
                                                    ))}

                                                    {/* Display button only if errors exist */}
                                                    <Button
                                                        sx={{
                                                            float: 'left',
                                                            marginTop: '2%',
                                                            ":hover": {
                                                                color: "white"
                                                            },
                                                            backgroundColor: abstractHomeSetup.color_code_two
                                                                ? abstractHomeSetup.color_code_two
                                                                : gradientBackground,
                                                        }}
                                                        size="small"
                                                        variant="contained"
                                                        onClick={handleExtraButtonClick}
                                                    >
                                                        Back to Step 1
                                                    </Button>
                                                </div>
                                            )}


                                            <Card sx={cardStyles} >
                                                <CardContent >
                                                    <Typography component="h1" variant="h5" sx={{
                                                        textAlign: 'center', // Center the text
                                                    }}>
                                                        Check Out
                                                    </Typography>
                                                    <Box component="form" noValidate sx={{ mt: 3 }}>

                                                        {renderSelectedWorkshopInfo()}

                                                    </Box>
                                                    <Grid container justifyContent="space-between">
                                                        {/* <Button
                                                            onClick={handleBack}
                                                            //sx={{ mt: 5 }}
                                                            sx={{
                                                                mt: 5,
                                                                backgroundColor: abstractHomeSetup.color_code_two
                                                                    ? abstractHomeSetup.color_code_two
                                                                    : gradientBackground,
                                                            }}>
                                                            Back
                                                        </Button> */}
                                                        {/* <Button
                                                            variant="contained"
                                                            color="primary"
                                                            // onClick={handleNext}
                                                            onClick={handleBack}
                                                            sx={{
                                                                mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                    ? abstractHomeSetup.color_code_two
                                                                    : gradientBackground,
                                                            }}
                                                        >
                                                            {activeStep === steps.length - 1 ? 'Back' : 'BAck'}
                                                        </Button> */}

                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Box>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    {/* <Typography>{steps[activeStep]}</Typography> */}
                                    {/* Render your form for each step */}
                                    {activeStep === 0 && (
                                        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
                                            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>


                                                <Button sx={{
                                                    float: 'right',
                                                    marginTop: '2%',
                                                    ":hover": {
                                                        color: "white"
                                                    }
                                                    , backgroundColor: abstractHomeSetup.color_code_two
                                                        ? abstractHomeSetup.color_code_two
                                                        : gradientBackground,
                                                }}
                                                    color='success'
                                                    size='small'
                                                    variant='contained'
                                                    component={Link}  // Use the Link component here
                                                    to="/workshop/particpant-verification" >
                                                    Back To Verification
                                                </Button>

                                                <Card sx={cardStyles}>
                                                    <CardContent >
                                                        {/* <Typography component="h1" variant="h5">
                                                        Add WorkShop Participant
                                                    </Typography> */}

                                                        <Box component="form" noValidate sx={{ mt: 3 }}>
                                                            <Grid container spacing={4}>


                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <FormControl fullWidth>
                                                                        <InputLabel id="demo-simple-select-label">Title</InputLabel>
                                                                        <Select
                                                                            value={nameTitle}
                                                                            onChange={handleNameTitle}
                                                                            labelId="demo-simple-select-label"
                                                                            id="demo-simple-select"
                                                                            label="Action" >
                                                                            <MenuItem value={'Mr'}>Mr</MenuItem>
                                                                            <MenuItem value={'Mrs'}>Mrs</MenuItem>
                                                                            <MenuItem value={'Ms'}> Ms</MenuItem>
                                                                            <MenuItem value={'Dr'}>Dr </MenuItem>
                                                                            <MenuItem value={'Prof'}>Prof</MenuItem>
                                                                            <MenuItem value={'Eng'}>Eng </MenuItem>
                                                                            <MenuItem value={'Sheikh'}>Sheikh</MenuItem>
                                                                        </Select>
                                                                        <FormHelperText>{addWorkShopParticpant.error_list.name_title}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>

                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        autoComplete="given-name"
                                                                        required
                                                                        fullWidth
                                                                        label="Full Name"
                                                                        autoFocus
                                                                        name='workShop_partecpant_name'
                                                                        onChange={handleInput} value={addWorkShopParticpant.workShop_partecpant_name || ""}
                                                                        helperText={addWorkShopParticpant.error_list.participant_name} />
                                                                </Grid>

                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        required
                                                                        fullWidth
                                                                        label="Saudi Council No"
                                                                        type="text"
                                                                        name='saudiCouncilno'
                                                                        onChange={handleInput} value={addWorkShopParticpant.saudiCouncilno || ""}
                                                                        helperText={addWorkShopParticpant.error_list.participant_saudi_council_no} />
                                                                    <span style={{ color: 'red', textAlign: 'center' }}>
                                                                        If you dont have just type 0000
                                                                    </span>
                                                                </Grid>
                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <FormControl fullWidth>
                                                                        <InputLabel id="demo-simple-select-label">Workshop Category</InputLabel>
                                                                        <Select

                                                                            value={registrationType || ""}
                                                                            // onChange={handleWorkShopCategory}
                                                                            onChange={handleregistration}
                                                                            labelId="demo-simple-select-label"
                                                                            id="demo-simple-select"
                                                                            label="Workshop Category" >
                                                                            {
                                                                                workshopCategoryData && workshopCategoryData.map((val, index) => {
                                                                                    return (
                                                                                        <MenuItem value={val.id} key={val.id}>{val.workshop_category_title} </MenuItem>
                                                                                    )
                                                                                })
                                                                            }



                                                                        </Select>

                                                                        <FormHelperText>{addWorkShopParticpant.error_list.participant_workshop_categoy}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        required
                                                                        fullWidth
                                                                        id="email"
                                                                        label="Email Address"
                                                                        autoComplete="particent_email"
                                                                        name='particent_email'
                                                                        onChange={handleInput} value={addWorkShopParticpant.particent_email || workshop_particpant_email}
                                                                        helperText={addWorkShopParticpant.error_list.participant_email} />
                                                                </Grid>
                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        required
                                                                        fullWidth
                                                                        label="Mobile"
                                                                        type="text"
                                                                        name='phone'
                                                                        onChange={handleInput} value={addWorkShopParticpant.phone || ""}
                                                                        helperText={addWorkShopParticpant.error_list.participant_contact}
                                                                    />
                                                                </Grid>


                                                                <Grid item xs={12} lg={6} sm={12} >
                                                                    <TextField
                                                                        autoComplete="given-name"
                                                                        required
                                                                        fullWidth

                                                                        label="Profession"
                                                                        autoFocus
                                                                        name='profession'
                                                                        onChange={handleInput} value={addWorkShopParticpant.profession || ""}
                                                                        helperText={addWorkShopParticpant.error_list.participant_profession} />
                                                                </Grid>
                                                                <Grid item xs={12} lg={6} sm={12} >
                                                                    <FormControl>
                                                                        <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel>
                                                                        <RadioGroup
                                                                            row
                                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                                            name="row-radio-buttons-group"
                                                                            value={gender}
                                                                            onChange={handleChange} >
                                                                            <FormControlLabel value="male" control={<Radio />} label="Male" />
                                                                            <FormControlLabel value="female" control={<Radio />} label="Female" />
                                                                        </RadioGroup>
                                                                        <FormHelperText>{addWorkShopParticpant.error_list.participant_gender}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>

                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <FormControl fullWidth >

                                                                        <InputLabel id="country-select-label">Country</InputLabel>
                                                                        <Select
                                                                            value={country}
                                                                            onChange={handleCountry}
                                                                            labelId="country-select-label"
                                                                            id="country-select"
                                                                            label="Country"
                                                                        >
                                                                            {countries.map((country) => (
                                                                                <MenuItem key={country} value={country}>
                                                                                    {country}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                        <FormHelperText></FormHelperText>
                                                                    </FormControl>
                                                                </Grid>

                                                                <Grid item xs={12} lg={6} sm={12} >
                                                                    <TextField
                                                                        autoComplete="given-name"
                                                                        required
                                                                        fullWidth
                                                                        label="City"
                                                                        autoFocus
                                                                        name='city' onChange={handleInput} value={addWorkShopParticpant.city || ""} />
                                                                </Grid>
                                                            </Grid>


                                                            <Grid container justifyContent="space-between">
                                                                <Button
                                                                    disabled={activeStep === 0}
                                                                    onClick={handleBack}
                                                                    sx={{ mt: 5, }}>
                                                                    Back
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={handleNext}
                                                                    sx={{
                                                                        mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                            ? abstractHomeSetup.color_code_two
                                                                            : gradientBackground,
                                                                    }}
                                                                >
                                                                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                                                </Button>
                                                            </Grid>

                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        </div>

                                    )}
                                    {activeStep === 1 && (
                                        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
                                            <Box sx={{ color: '#000000', mt: '5%' }}>
                                                <Card sx={cardStyles}>
                                                    <CardContent>
                                                        <Typography component="h1" variant="h5" sx={{ textAlign: 'center' }}>
                                                            WorkShop Registration
                                                        </Typography>
                                                        <Box component="form" noValidate sx={{ mt: 3 }}>
                                                            <Grid container spacing={4}>
                                                                <Grid item xs={12} sm={6} md={4} lg={6}>
                                                                    <Box display="flex" alignItems="center">
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    color="success"
                                                                                    checked={singleWorkShopCategory.workshop_category_title !== null}
                                                                                />
                                                                            }
                                                                            label="WorkShop Registration"
                                                                            name="permissions"
                                                                        />
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container justifyContent="space-between">
                                                                <Button
                                                                    disabled={activeStep === 0}
                                                                    onClick={handleBack}
                                                                    sx={{
                                                                        mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                            ? abstractHomeSetup.color_code_two
                                                                            : gradientBackground,
                                                                    }}
                                                                >
                                                                    Back
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={handleNext}
                                                                    sx={{
                                                                        mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                            ? abstractHomeSetup.color_code_two
                                                                            : gradientBackground,
                                                                    }}
                                                                >
                                                                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                                                </Button>
                                                            </Grid>
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        </div>
                                    )}

                                    {activeStep === 2 && (
                                        <div style={{ margin: '1%', width: '100%' }}>
                                            <Box sx={{ color: '#000000', mt: { xs: '2%', md: '5%' } }}>

                                                <Card sx={{ width: '100%' }}>
                                                    <CardContent>
                                                        <Typography component="h1" variant="h5" sx={{ textAlign: 'center' }}>
                                                            Registration Fees
                                                        </Typography>
                                                        <br />
                                                        <Typography component="h6" variant="h5" sx={{ textAlign: 'center', color: 'red' }}>
                                                            {addWorkShopParticpant.error_list.selectedWorkshopAmounts}
                                                        </Typography>

                                                        <Box component="form" noValidate sx={{ mt: 3 }}>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12}>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                color="success"
                                                                                checked={singleWorkShopCategory.workshop_category_title !== null}
                                                                            />
                                                                        }
                                                                        label={
                                                                            <span style={{ margin: '55px', display: 'inline-block' }}>
                                                                                {singleWorkShopCategory.workshop_category_title}
                                                                            </span>
                                                                        }
                                                                        name="permissions"
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={12}>
                                                                    <TableContainer component={Paper}>
                                                                        <Table>
                                                                            <TableHead>
                                                                                <TableRow>
                                                                                    {
                                                                                        isMobile ? (
                                                                                            <>
                                                                                                <TableCell colSpan={5} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                                                                    Workshop Informations
                                                                                                </TableCell>
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <TableCell>ID</TableCell>
                                                                                                <TableCell>Workshop Name</TableCell>
                                                                                                <TableCell>Workshop Day</TableCell>
                                                                                                <TableCell>Workshop Date</TableCell>
                                                                                                <TableCell>Start Time</TableCell>
                                                                                                <TableCell>End Time</TableCell>
                                                                                                <TableCell>Code</TableCell>
                                                                                                <TableCell>Price</TableCell>
                                                                                                <TableCell>Select</TableCell>
                                                                                            </>

                                                                                        )}

                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>

                                                                                {/* {singleWorkShopCategory.work_shops &&
                                                                                    singleWorkShopCategory.work_shops.map((row, i) => (
                                                                                        <TableRow key={row.id} style={{ backgroundColor: isCheckboxDisabled(row).color }}>
                                                                                            <TableCell style={{ color: 'white' }}>{i + 1}</TableCell>
                                                                                            <TableCell>{row.workshop_name}</TableCell>
                                                                                            <TableCell>{row.workshop_url}</TableCell>
                                                                                            <TableCell>{row.workshop_date}</TableCell>
                                                                                            <TableCell>{row.workshop_start_time}</TableCell>
                                                                                            <TableCell>{row.workshop_end_time}</TableCell>
                                                                                            <TableCell>{row.workshop_code}</TableCell>
                                                                                            <TableCell>{row.workshop_amount}</TableCell>
                                                                                            <TableCell>
                                                                                                <Checkbox
                                                                                                    checked={selectedWorkshops.some(
                                                                                                        (selectedWorkshop) => selectedWorkshop.id === row.id
                                                                                                    )}
                                                                                                    onChange={(e) => handleCheckboxChange(e, row, row.workshop_amount)}
                                                                                                    disabled={isCheckboxDisabled(row).isDisabled}
                                                                                                />
                                                                                                <br />
                                                                                                {isCheckboxDisabled(row).seatLimitMessage && (
                                                                                                    <span style={{ color: 'red' }}>
                                                                                                        {isCheckboxDisabled(row).seatLimitMessage}
                                                                                                    </span>
                                                                                                )}
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    ))} */}
                                                                                {singleWorkShopCategory.work_shops &&
                                                                                    singleWorkShopCategory.work_shops.map((row, i) => {
                                                                                        const { isDisabled, color, seatLimitMessage } = isCheckboxDisabled(row);
                                                                                        // console.log('Row Color:', color, "row", i + 1);
                                                                                        //const textColor = color === '#fff' || color === 'white' ? 'black' : 'white';
                                                                                        //const textColor = (color.toLowerCase() === '#fff' || color.toLowerCase() === '#fff') ? 'black' : 'white';
                                                                                        const normalizedColor = color ? color.toLowerCase() : '';
                                                                                        const textColor = (['#fff', '#ffffff', 'white'].includes(normalizedColor)) ? 'black' : 'white';
                                                                                        return (
                                                                                            <TableRow key={row.id} style={{ backgroundColor: color || '#ffffff' }}>
                                                                                                {
                                                                                                    isMobile ? (
                                                                                                        <>
                                                                                                            <TableCell style={{ display: 'flex', flexWrap: 'wrap', flexBasis: '100%', paddingLeft: '20px' }}>
                                                                                                                <strong>No:  {i + 1} </strong>
                                                                                                                
                                                                                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                    <strong>Workshop Name:</strong> {row.workshop_name}

                                                                                                                </Box>
                                                                                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                    <strong>Workshop Day:</strong> {row.workshop_url}

                                                                                                                </Box>

                                                                                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                    <strong>Workshop Date:</strong> {row.workshop_date}

                                                                                                                </Box>

                                                                                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                    <strong>Workshop Start:</strong> {row.workshop_start_time}

                                                                                                                </Box>

                                                                                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                    <strong>Workshop End:</strong> {row.workshop_end_time}

                                                                                                                </Box>
                                                                                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                    <strong>Workshop Code:</strong> {row.workshop_code}
                                                                                                                </Box>

                                                                                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                    <strong>Workshop Amount:</strong> {row.workshop_amount}
                                                                                                                </Box>
                                                                                                                <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                                                                                    <strong>Select Conference:</strong>
                                                                                                                    <Checkbox
                                                                                                                    checked={selectedWorkshops.some(
                                                                                                                        (selectedWorkshop) => selectedWorkshop.id === row.id
                                                                                                                    )}
                                                                                                                    onChange={(e) => handleCheckboxChange(e, row, row.workshop_amount)}
                                                                                                                    disabled={isDisabled}
                                                                                                                />
                                                                                                                <br />
                                                                                                                {seatLimitMessage && (
                                                                                                                    <span style={{ color: 'red' }}>
                                                                                                                        {seatLimitMessage}
                                                                                                                    </span>
                                                                                                                )}
                                                                                                                    </Box>

                                                                                                            </TableCell>

                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <TableCell style={{ color: textColor }}>{i + 1}</TableCell>
                                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_name}</TableCell>
                                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_url}</TableCell>
                                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_date}</TableCell>
                                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_start_time}</TableCell>
                                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_end_time}</TableCell>
                                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_code}</TableCell>
                                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_amount}</TableCell>
                                                                                                            <TableCell>
                                                                                                                <Checkbox
                                                                                                                    checked={selectedWorkshops.some(
                                                                                                                        (selectedWorkshop) => selectedWorkshop.id === row.id
                                                                                                                    )}
                                                                                                                    onChange={(e) => handleCheckboxChange(e, row, row.workshop_amount)}
                                                                                                                    disabled={isDisabled}
                                                                                                                />
                                                                                                                <br />
                                                                                                                {seatLimitMessage && (
                                                                                                                    <span style={{ color: 'red' }}>
                                                                                                                        {seatLimitMessage}
                                                                                                                    </span>
                                                                                                                )}
                                                                                                            </TableCell>
                                                                                                        </>
                                                                                                    )}

                                                                                            </TableRow>
                                                                                        );
                                                                                    })}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Grid>

                                                                <Grid container justifyContent="space-between">
                                                                    <Button

                                                                        disabled={activeStep === 0}
                                                                        onClick={handleBack}
                                                                        sx={{
                                                                            ml: 3,
                                                                            mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                                ? abstractHomeSetup.color_code_two
                                                                                : gradientBackground,
                                                                        }}>
                                                                        Back
                                                                    </Button>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        onClick={handleNext}
                                                                        sx={{
                                                                            mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                                ? abstractHomeSetup.color_code_two
                                                                                : gradientBackground,
                                                                        }}
                                                                    >
                                                                        {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                                                                    </Button>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        </div>
                                    )}






                                    {/* Add your form components here */}
                                    {/* <Grid container justifyContent="space-between">
                                    <Button
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        sx={{ mt: 5 }}>
                                        Back
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleNext}
                                        sx={{ mt: 5, backgroundColor: '#145348' }}
                                    >
                                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                    </Button>
                                </Grid> */}
                                </div>
                            )}
                        </div>

                    </Grid >
                </Grid >
            </Grid >

            <Grid item xs={12} sm={10} md={8} lg={6} marginTop="40px">
                <NewVersionAbstractFooter />
            </Grid>
        </div >
    );
};

export default WorkShopParticpantForm;
